import { VisioLink } from '@gozoki/api-types';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { fetchAskVisio } from '../queries/visio.queries';

export const useVisio = (
    kioskId: number | null,
    includeVideo: boolean,
    shouldStartCall: boolean
): UseQueryResult<VisioLink> => {
    return useQuery({
        queryKey: ['visio', kioskId],
        queryFn: () => fetchAskVisio(kioskId as number, includeVideo),
        enabled: shouldStartCall && !!kioskId !== null,
    });
};
